import { StackStatus } from "../../../services/backend_gateway/__generated__/backend_gateway-types";
import { AlertsComponent } from "./component";

export const AlertsContainer = (props: {
  deploymentId: string;
  navigateToHelp: (stepId: string) => void;
  alertsStackStatus: StackStatus | null;
}) => {
  const { deploymentId, alertsStackStatus } = props;

  return (
    <AlertsComponent
      loading={false}
      deploymentId={deploymentId}
      alertsStackParamsJson={alertsStackStatus?.parametersJSON || null}
      alertsStackStatus={alertsStackStatus?.status || null}
    />
  );
};
